import React from 'react';
import { ModuleInterface } from '../types';
import { Checkbox } from 'ui';
import { useT } from 'hooks/Locale/useT';

interface StaticCheckboxFieldProps extends ModuleInterface {}

/**
 * Static checkbox group for the generic Filter modal — no endpoint, options
 * come from `manualOptions` (value => translation key). Form value is an
 * array of the checked option values.
 */
const StaticCheckboxField: React.FC<StaticCheckboxFieldProps> = ({ layout, ...field }) => {
    const t = useT();

    const options = Object.entries(field.manualOptions ?? {}).map(([value, labelKey]) => ({
        value,
        label: t(labelKey),
    }));

    return (
        <Checkbox
            label={field.label}
            name={field.name}
            options={options}
            customLayout={layout}
            validation={{ required: field.required ?? false }}
        />
    );
};

export default StaticCheckboxField;
